module.exports = __webpack_public_path__ + "static/headshot-henry-stamerjohan.68952dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-henry-stamerjohan.jpg
// module id = 524
// module chunks = 152909308826437